$(document).ready(function(){
  //sticky nav
  var nav = $('.site-header');
  $(window).on('scroll', () => {
    if(window.scrollY > 72){
      nav.addClass('sticky');
    } else {
      nav.removeClass('sticky');
    }
  })
  if($('.template-product').length){
    if(location.search.split('=').includes('variant')){

    }
    if($('.single-option-selector').length == 1){
      $('.single-option-selector').change(updateQty);
      //var tags = [{% for tag in product.tags%} '{{tag}}' {% endfor %}]
      //var noStock = tags.filter(function(tag) {
      //  if(tag.split(':')[0] == 'noStock'){
      //    return tag
      //  }
      //})
      //noStock = noStock.map(function(tag){
      //  return tag.split(':')[1];
      //})
      function updateQty(){
        var quantity = $(this).find(":selected").data('quantity');
        var variant = $(this).find(":selected").val();
        var singlePlur = 'are '
        if(quantity == 1){
          singlePlur = 'is ' 
        }
        if(!variant){
          variant = $('.single-option-selector').find("option:first-child").val()
        }
        if(quantity === undefined){
          quantity = $('.single-option-selector').find("option:first-child").data('quantity')
        }
        console.log('triggered')
        //noStock.includes(variant) ? 
        //  $('.noStock-message').css('display', 'block')
        //  :
        //  $('.noStock-message').css('display', 'none');
    
        $('.item-qty').text('There ' + singlePlur + quantity.toString() + ' left in stock');
    
        // update thumbnail
        $('.product-single__thumbnail-image[data-variant="'+ $(this).data('variant') +'"]').click();
      }
      // on load
      updateQty()
    
      //update dropdown
      $('.product-single__thumbnail-image').on('click', function(){
        var variantId = $(this).data('variant');
        $('.single-option-selector').val($('.single-option-selector option[data-variant="'+ variantId +'"]').val()).trigger('change');
      })
    } else if($('.single-option-selector').length == 2) {
      $('.single-option-selector').change(updateQty);
    
      function updateQty(){
        var size = $('#SingleOptionSelector-0').val();
        var fragrance = $('#SingleOptionSelector-1').val();
        var quantity = $('input[data-fragrance="'+ fragrance +'"][data-size="'+ size +'"]').data('qty');
        var variantData = $('input[data-fragrance="'+ fragrance +'"][data-size="'+ size +'"]')
        var singlePlur = 'are '
        if(quantity == 1){
          singlePlur = 'is ' 
        }
        //noStock.includes(variant) ? 
        //  $('.noStock-message').css('display', 'block')
        //  :
        //  $('.noStock-message').css('display', 'none');
        if(variantData.length){
          $('.item-qty').text('There ' + singlePlur + quantity.toString() + ' left in stock');
        } else {
          $('.item-qty').text('');
        }
    
        setTimeout(function(){
          if($('#AddToCart-product-template[disabled]').length){
            $('.item-qty').text('');
          }
        }, 100)
    
    
        // update dropdown availibility
        $('form option').removeAttr('disabled', false);
        $('#SingleOptionSelector-1 option').each(function(){
          var option = $(this).val();
          var optionCheck = $('.variantData[data-fragrance="'+ option +'"][data-size="'+ size +'"]').length
          if(optionCheck == 0){
            $(this).attr('disabled', true);
          }
        })
      }
      updateQty()
    } else {
        var quantity = $('.product-single__meta').data('qty');
        var singlePlur = 'are '
        if(quantity == 1){
          singlePlur = 'is ' 
        }
      if($('.single-option-selector').length == 1){
       $('.item-qty').text('There ' + singlePlur + quantity.toString() + ' left in stock');
      }
    }
  }
})
